export default __webpack_public_path__ + "static/media/logo-uniao-europeia.763fee5c.svg";